import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { ClipboardCheck, Loader2 } from 'lucide-react';
import { useNotify, useRecordContext, useUpdate } from 'ra-core';
import { useState } from 'react';
import { VENDOR_APPROVERS } from './vendorConstants';

export const CheckVendorButton = () => {
    const record = useRecordContext();
    const notify = useNotify();
    const [update, { isPending }] = useUpdate();
    const [open, setOpen] = useState(false);
    const [checkedBy, setCheckedBy] = useState('');

    // Only relevant before final approval / blacklist
    if (!record || ['approved', 'conditional', 'blacklisted', 'checked'].includes(record.status)) return null;

    const handleCheck = () => {
        update(
            'vendors',
            {
                id: record.id,
                data: {
                    status: 'checked',
                    checked_by: checkedBy || null,
                    checked_at: new Date().toISOString(),
                },
                previousData: record,
            },
            {
                onSuccess: () => {
                    notify('Vendor marked as Checked', { type: 'success' });
                    setOpen(false);
                },
                onError: (error: any) => {
                    notify(`Error updating vendor: ${error.message}`, { type: 'error' });
                },
            }
        );
    };

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                disabled={isPending}
                variant="outline"
                size="sm"
                className="text-cyan-700 border-cyan-200 hover:bg-cyan-50 gap-2"
            >
                <ClipboardCheck className="w-4 h-4" />
                Mark Checked
            </Button>

            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Mark Vendor as Checked</DialogTitle>
                        <DialogDescription>
                            Record who verified <span className="font-semibold">{record.name}</span> before approval.
                        </DialogDescription>
                    </DialogHeader>

                    <div className="space-y-2 py-2">
                        <Label htmlFor="checked_by">Checked By</Label>
                        <select
                            id="checked_by"
                            value={checkedBy}
                            onChange={(e) => setCheckedBy(e.target.value)}
                            className="w-full h-9 rounded-md border border-input bg-background px-3 text-sm"
                        >
                            <option value="">Select reviewer…</option>
                            {VENDOR_APPROVERS.map((a) => (
                                <option key={a.id} value={a.id}>{a.name}</option>
                            ))}
                        </select>
                    </div>

                    <DialogFooter>
                        <Button variant="outline" onClick={() => setOpen(false)} disabled={isPending}>
                            Cancel
                        </Button>
                        <Button onClick={handleCheck} disabled={isPending} className="gap-2">
                            {isPending ? <Loader2 className="w-4 h-4 animate-spin" /> : <ClipboardCheck className="w-4 h-4" />}
                            Confirm
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
};
